<template>
  <div>
    <a class="text-uppercase text-decoration-none" :href="url">Forgotten your password?</a>
  </div>
</template>

<script>
/**
 * Renders a password reset link
 */
export default {
  name: 'ForgotYourPasswordLink',
  data () {
    return {
      /**
       * The url of the password reset page
       */
      url: this.$root.config.reset_password_url
    }
  }
}
</script>

<style lang="sass">
  //
</style>
